import React, { Component } from 'react'
import { connect } from 'react-redux'

import { updateUserSettings } from '../../actions'

import { Form, Input, Button, Select, Icon } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

class AppSettingsMySettings extends Component {
  handleSubmit = e => {
    e.preventDefault()
    const { form, user: { settings }, updateUserSettings } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        const updatedUserSettings = {
          ...settings,
          name: values.name,
          lang: values.lang
        }

        updateUserSettings(updatedUserSettings)
      } else {
        console.log(err)
      }
    })
  }

  render () {
    const { form: { getFieldDecorator }, loading, user: { settings } } = this.props

    return (
      <div>
        {settings &&
          <Form onSubmit={this.handleSubmit}>

            <p>E-mail: {settings.email}</p>

            <FormItem label='Name'>
              {getFieldDecorator('name', {
                initialValue: settings.name,
                rules: [{ required: true, message: 'Please input your name!' }]
              })(<Input prefix={<Icon type='user' style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder='Name' />)}
            </FormItem>

            <FormItem label='Language' hasFeedback>
              {getFieldDecorator('lang', {
                initialValue: settings.lang,
                rules: [{ required: true }]
              })(
                <Select>
                  <Option value='de'>Deutsch</Option>
                  <Option value='en'>English</Option>
                </Select>
              )}
            </FormItem>

            <Button type='primary' htmlType='submit' loading={loading.updateUserSettings}>Update profile</Button>

          </Form>}
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user,
  loading: state.loading
})

const mapDispatchToProps = {
  updateUserSettings
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(AppSettingsMySettings))



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingsMySettings.js